<template>
  <div class="containerh5">
    <!-- header导航 -->
    <Iheaders class="header" :show="show" @setShow="setShow"></Iheaders>
    <div class="content" ref="content">
      <Hmenu
        :class="show ? 'active' : ''"
        class="menu"
        @setShow="setShow"
        :show="show"
      ></Hmenu>
      <keep-alive>
        <!-- <transition name="fade" mode="out-in" appear> -->
        <router-view> </router-view>
        <!-- </transition> -->
      </keep-alive>
      <!-- 底部 -->
      <Ifooter></Ifooter>
    </div>
  </div>
</template>
<script>
import iheader from "@/h5/headerH5.vue";
import Ifooter from "@/h5/footerH5.vue";
import Hmenu from "@/h5/menu.vue";

export default {
  components: {
    Iheaders: iheader,
    Ifooter: Ifooter,
    Hmenu: Hmenu,
  },
  data() {
    return {
      show: false,
    };
  },
  activated() {
    console.log(this.$refs.content);
  },
  methods: {

    setShow(e) {
      this.show = e;
    },
  },
};
</script>
<style lang="less" scoped>
.containerh5 {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .content {
    width: 100vw;
    overflow: hidden;
    flex: 1;
    overflow-y: auto;
    position: relative;
    .menu {
      width: 750px;
      position: fixed;
      height: 100%;
      right: 750px;
      top: 100px;
      z-index: 99;
      margin: 0;
      overflow: hidden;
      overflow-y: scroll;
      background: #f5f7fa;
      transition: width 0.2s;
      &.active {
        right: 0;
        top: 100px;
        overflow: hidden;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/h5/mobile.vue